<template>
  <v-dialog persistent scrollable max-width="750" :value="showDialog">
    <v-card min-height="500">
      <v-card-title class="text-h5">
        Passenger Search
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="searchInput"
          @input="debouncedLoad()"
          clearable
          :placeholder="$t('components.passengerSearch.searchPlaceholder')"
          solo
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
        <v-divider></v-divider>

        <div class="fleet-list" v-if="!isLoading">
          <v-list>
            <v-list-item-group v-for="(passenger, index) in passengers" :key="index">
              <v-list-item three-line class="hoverable" @click="passengerSelected(passenger)">
                <v-list-item-content>
                  <v-list-item-title class="title blue--text">
                    {{ passenger.givenName }} {{ passenger.familyName }}
                    <br>
                    <span class="subtitle-2 font-italic font-weight-bold text--primary">
                      {{ passenger.phoneNumber }} {{ passenger.email }}
                    </span>
                    <v-chip
                      class="ml-2"
                      small
                    >
                      {{ passenger.passengerType }}
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="d-flex flex-row align-center">
                      <span class="pr-1">
                       Created:
                      </span>
                      <span>
                        {{ passenger.createdAt }} UTC
                      </span>
                    </div>
                  </v-list-item-subtitle>

                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>

        <div class="shimmers" v-if="isLoading">
          <v-progress-linear
            indeterminate
          ></v-progress-linear>
          <br>
          <v-divider class="mt-1 white"></v-divider>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="closeDialog"
          color="grey"
          text
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from 'debounce';

export default {
  name: 'PassengerSearchDialog',
  components: {
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    businessAccountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      searchInput: '',
      passengers: [],
    };
  },
  created() {
    this.debouncedLoad = debounce(this.listPassengers, 500);
  },
  methods: {
    async listPassengers() {
      if (this.searchInput.length < 3) return;
      this.isLoading = true;
      const payload = {
        page: 0,
        maxPerPage: 100,
        dynamicSearch: this.searchInput,
      };
      const businessPassengers = await this.$store.dispatch('businessPassenger/getBusinessPassengerList', { ...payload, businessAccountIds: [this.businessAccountId] });
      const businessGuests = await this.$store.dispatch('businessGuest/getBusinessGuestList', { ...payload, businessAccountId: this.businessAccountId });
      const passengers = [...businessPassengers.results, ...businessGuests.results];
      const mappedPassengers = [];
      passengers.forEach((passenger) => {
        if (passenger.passenger) {
          mappedPassengers.push({ ...passenger.passenger, passengerType: 'PASSENGER' });
        } else {
          mappedPassengers.push({ ...passenger, passengerType: 'GUEST' });
        }
      });
      this.passengers = mappedPassengers;
      this.isLoading = false;
    },
    passengerSelected(passenger) {
      this.$emit('passengerSelected', passenger);
      this.passengers = [];
      this.searchInput = null;
    },
    closeDialog() {
      this.$emit('closeClick');
      this.passengers = [];
      this.searchInput = null;
    },
  },
};
</script>

<style scoped>

</style>
